<style lang="less">
    .page_con.sentence{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background:url("../assets/images/topbar-6.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.6rem;
                height:auto;
                display: block;
            }
            p{
                font-size: .4rem;
                color:#fff;
                font-weight: bold;
                margin-left:.1rem;
                letter-spacing: .05rem;
            }
        }
        .content_con{
            width:100%;
            height:79vh;
            .part1{
                .question_con{
                    width:100%;
                    height:30vh;
                    background:#FCD687;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .5rem;
                    line-height: 1.5;
                    font-weight: bold;
                    letter-spacing: .05rem;
                    padding:0 8vw;
                }
                .opt_con{
                    width:100%;
                    padding:1vh 5vw;
                    .opt_tips{
                        width: 100%;
                        font-size: .4rem;
                        letter-spacing: .05rem;
                        margin-bottom: 5vh;
                    }
                    .opts{
                        width:100%;
                        >div{
                            width:100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            padding:0 5vw;
                            margin-bottom: 3vh;
                            font-size: .4rem;
                            .circle{
                                width:7vw;
                                height:7vw;
                                border-radius: 50%;
                                box-shadow: 0 0 0.1rem 0.05rem inset rgba(0, 0, 0, 0.5);
                                background:#fff;
                                margin-right:5vw;
                                img{
                                    display: none;
                                    width:120%;
                                    height:auto;
                                }
                            }
                            .circle.active{
                                img{
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
            .part2{
                .question_con{
                    width:100%;
                    height:30vh;
                    background:#FCD687;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .5rem;
                    line-height: 1.5;
                    font-weight: bold;
                    letter-spacing: .05rem;
                    padding:0 8vw;
                }
                .opt_con{
                    width:100%;
                    padding:1vh 5vw;
                    .opt_tips{
                        width: 100%;
                        font-size: .4rem;
                        letter-spacing: .05rem;
                        margin-bottom: 5vh;
                    }
                    .opts{
                        width:100%;
                        >div{
                            width:100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            padding:0 5vw;
                            margin-bottom: 3vh;
                            font-size: .4rem;
                            .circle{
                                width:7vw;
                                height:7vw;
                                border-radius: 50%;
                                box-shadow: 0 0 0.1rem 0.05rem inset rgba(0, 0, 0, 0.5);
                                background:#fff;
                                margin-right:5vw;
                                img{
                                    display: none;
                                    width:120%;
                                    height:auto;
                                }
                            }
                            .circle.active{
                                img{
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
        }
        .btns{
            width:100%;
            height:10vh;
            // position: fixed;
            bottom: 0;
            left: 0;
            z-index: 11;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width:25vw;
                height:auto;
                display: block;
            }
        }
    }
</style>
<template>
    <div class="page_con sentence">
        <div class="top_con">
            <img src="../assets/images/time.png" alt="">
            <interval :time="time" ref="time"></interval>
        </div>
        <!-- <div class="quest_num">
            <img src="../assets/images/grade-button.png" alt="">
            <p>第112題</p>
        </div> -->
        <div class="content_con">
            <div class="part1" v-if="part === 1">
                <div class="question_con">
                    <p>
                        <span v-for="(item,index) in data.part1.questions" :key="index" :style="'background:'+item.color">{{item.option}}</span>
                    </p>
                </div>
                <div class="opt_con">
                    <div class="opt_tips">
                        語誤判斷：請判斷上面句子哪一部分有語誤？
                    </div>
                    <div class="opts">
                        <div v-for="(item,index) in data.part1.options" :key="index" @click="choicedPart(1,index,item.right)">
                            <div :class="['circle',data.part1.choiced===index?'active':'']">
                                <img src="../assets/images/yes.png" alt="">
                            </div>
                            <p><span :style="'background:'+item.color">{{item.option}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part2" v-if="part === 2">
                <div class="question_con">
                    <p v-html="data.part2.question"></p>
                </div>
                <div class="opt_con">
                    <div class="opt_tips">
                        {{data.part2.opt_tips}}
                    </div>
                    <div class="opts">
                        <div v-for="(item,index) in data.part2.opts" :key="index" @click="choicedPart(2,index,item.right)">
                            <div :class="['circle',data.part2.choiced===index?'active':'']">
                                <img src="../assets/images/yes.png" alt="">
                            </div>
                            <p><span>{{item.text}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part2" v-if="part === 3">
                <div class="question_con">
                    <p v-html="data.part3.question"></p>
                </div>
                <div class="opt_con">
                    <div class="opt_tips">
                        {{data.part3.opt_tips}}
                    </div>
                    <div class="opts">
                        <div v-for="(item,index) in data.part3.opts" :key="index" @click="choicedPart(3,index,item.right)">
                            <div :class="['circle',data.part3.choiced===index?'active':'']">
                                <img src="../assets/images/yes.png" alt="">
                            </div>
                            <p><span>{{item.text}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns">
            <img src="../assets/images/back-button.png" @click="$router.go(-1)" alt="">
            <img v-if="data['part'+part].tips" src="../assets/images/tip-button.png" @click="openTip" alt="">
            <img src="../assets/images/submit.png" @click="submit" alt="">
        </div>
        
        <div class="shade" v-if="tips_bag || toast != 'none'">
            <div class="tips_bag" v-if="tips_bag">
                <img src="../assets/images/tip-bg.png" alt="">
                <img class="close" src="../assets/images/close-tipbutton.png" alt="" @click="tips_bag='close'">
                
                <p v-if="data.part2.tips" v-html="data.part2.tips"></p>
                <p v-else style="text-align:center;" v-html="'今天沒有學習錦囊'"></p>
            </div>


            <div class="toast" v-if="toast != 'none'">
                <div v-if="toast == 'success'" class="toast_success">
                    <template v-if="isEnd">
                        <img class="result" src="../assets/images/DONE-answer.png" alt="">
                        <img src="../assets/images/backhome.png" alt="" class="goon" @click="answerEnd">
                    </template>
                    <template v-else>
                        <img class="result" src="../assets/images/yes-answer.png" alt="">
                        <img src="../assets/images/next.png" alt="" class="goon" @click="next">
                    </template>
                </div>
                <div v-if="toast == 'error'" class="toast_error">
                    <img class="result" src="../assets/images/NO-answer.png" alt="">
                    <img src="../assets/images/continue.png" alt="" class="goon" @click="reset">
                </div>
            </div>
        </div>
        <div class="shade tips_result" v-if="tips_bag == 'close'">
            <div class="tips_result">
                <img class="readed" src="../assets/images/read-done.png" alt="">
                <img class="close" @click="tips_bag=false" src="../assets/images/certain-button.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import interval from './timer';
export default {
    components:{
        interval
    },
    data(){
        return {
            pauseStatus:false,  //暫停狀態
            time:300,    //倒計時

            //多套题记录
            setsIndex:0,        //当前第几套题
            // setsAnswers:[],     //答题结果

            allRight:1,        //是否全对    规则：所有小题全对才算对
            is_right:1,         //当前题目选择的结果是否正确

            tips_bag:'',
            toast:'none',
            tips_time:0,        //锦囊使用次数

            isEnd:false,        //是否结束
            part:1,
            colors_src:['#D37686','#F8B72C','#8DC21F','#7BCCE8','#00913A','#595757','#956134','#8C7AB7','#2FA8E1'],
            colors:[],
            data:{
                tips:'',
                part1:{
                    choiced:'',
                    tips:false,
                    questions:[],
                    options:[
                        // {
                        //     text:'我家的小狗',
                        //     id:'1',
                        //     color:'#D37686',
                        // },
                    ],
                },
                part2:{
                    choiced:'',
                    tips:true,
                    question:[
                        // {
                        //     text:'我家的小狗',
                        //     id:'1',
                        //     color:'transparent',
                        // },
                    ],
                    opt_tips:'請指出以上句子錯誤的原因。',
                    opts:[
                        // {
                        //     text:'動詞錯誤',
                        //     id:'1',
                        // },
                    ],
                },
                part3:{
                    choiced:'',
                    tips:false,
                    question:[
                        // {
                        //     text:'我家的小狗',
                        //     id:'1',
                        //     color:'transparent',
                        // },
                    ],
                    opt_tips:'語誤判斷：請選出語誤句子裡做出適當修改',
                    opts:[
                        // {
                        //     text:'動詞錯誤',
                        //     id:'1',
                        // },
                    ],
                },
            }
        }
    },
    mounted() {
        let query = this.$route.query;
        this.getData(query.date);
    },
    methods:{
        answerEnd(){
            this.updateData(this.getTime(),this.tips_time,this.is_right,this.$route.query.date);
        },
        choicedPart(part,index,right){
            this.data['part'+part].choiced = index;
            this.is_right = right;
            console.log(this.is_right);
        },
        reset(){        //重置当前小题
            this.toast = 'none';
            this.data['part'+this.part].choiced = '';
        },
        next(){
            this.part += 1;
            this.toast = 'none';
            this.is_right = '';
        },
        hasMore(){
            let setsIndex = this.setsIndex + 1;
            if(this.$store.getters.gameData[setsIndex]){
                return true;
            }else{
                return false;
            }
        },
        getTime(){
            return this.time - this.$refs.time.getTime();
        },
        submit(){
            let part = this.part + 1;
            if(this.data['part'+part]){     //有数据 没答完
                if(!this.is_right){     //默认全对，有一个错了就不是全对
                    // this.allRight = 0;
                    this.toast = 'error';
                }else{
                    this.toast = 'success';
                }
                
                // this.part = part;
            }else{              //当前套题已答完
                if(this.is_right){
                    if(this.hasMore()){
                        this.setsIndex += 1;
                        this.part = 1;
                        this.init(this.setsIndex);
                        this.reset();
                    }else{
                        this.isEnd = true;
                        this.toast = 'success';
                    }
                }else{
                    this.toast = 'error';
                }
                // let setsIndex = this.setsIndex;
                // setsIndex+=1;
                // if(setsIndex = this.$store.getters.gameData.length){    //所有套题答完
                //     this.isEnd = true;
                //     // this.$router.push('/index');
                // }else{
                // }
                // this.toast = this.is_right?'success':'error';
            }
        },
        openTip(){
            this.tips_bag='open';
            this.tips_time++;
        },
        getData(date){
            let vm = this;
            vm.$http.get('/GameDaily/index?type=12&rest_key=1'+(date?('&pushdate='+date):'')).then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setGameData',res.data.data.game);
                    vm.init(vm.setsIndex);
                }
            })
        },
        init(sets){
            let vm = this;
            let data = JSON.parse(JSON.stringify(this.$store.getters.gameData[sets]));
            this.colors = JSON.parse(JSON.stringify(this.colors_src));

            //part1
            // let d = data.games[0].options.map((v,i)=>{
            //     v.color = vm.colors[i];
            //     // if(!(v.right===1 || v.right===0)){
            //     //     v.right=i==0?1:0;
            //     // }
            //     return v;
            // })
            let d = data.games[0].options.filter((v,i)=>{
                v.color = vm.colors[i];
                return v.option;
            })
            vm.data.part1.tips=false;
            let questions = JSON.parse(JSON.stringify(d));
            d = this.randomIndex(d);
            vm.$set(vm.data.part1,'options',d);
            this.data.part1.options = d;
            this.data.part1.questions = questions;
            

            //part2
            let p2 = data.games[1];
            this.data.part2 = this.dataInit(p2,data.topics.replace(p2.word,'<span style="background:#8DC21F;">'+p2.word+'</span>'));

            //part3
            let p3 = data.games[2];
            this.data.part3 = this.dataInit(p3,data.topics.replace(p3.word,'<span style="background:#8DC21F;">'+p3.word+'</span>'));
            console.log(this.data);
        },
        dataInit(obj,question){
            let data = {
                choiced:'',
                tips:obj.tips?obj.tips.replace('<rn>','<br><br>'):'',
                opts:this.randomIndex(obj.options.map((v,i)=>{
                    return {
                        text:v,
                        id:i,
                        right:i==0?1:0,
                        color:'transparent'
                    } 
                })),
                question:question,
            }
            
            return data;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/sentence.vue